<div class="agpr-listFilterSelect">
    <div
        *ngIf="dropdownSelectorOptions"
        class="agpr-listFilterSelect-dropdownSelector"
    >
        <agpr-dropdown
            [id]="id + '_dropdown'"
            class="agpr-listFilterSelect-dropdownSelector-dropdown"
            [options]="dropdownSelectorOptions.options"
            [(ngModel)]="dropdownSelectorOptions.selectedOption"
            (ngModelChange)="onDropdownChanged($event.value)"
        ></agpr-dropdown>

        <agpr-text-input
            [id]="id + '_listFilterTextInput'"
            class="agpr-listFilterSelect-filterInput"
            [bottomMargin]="false"
            [placeholder]="placeholder"
            [label]="textInputLabel"
            [ariaLabel]="textInputAriaLabel"
            [(ngModel)]="searchText"
            (ngModelChange)="setFilteredListItems()"
        ></agpr-text-input>
    </div>

    <div class="agpr-listFilterSelect-toolbar">
        <agpr-text-input
            *ngIf="!dropdownSelectorOptions"
            [id]="id + '_listFilterTextInput'"
            [bottomMargin]="false"
            [placeholder]="placeholder"
            [label]="textInputLabel"
            [ariaLabel]="textInputAriaLabel"
            [(ngModel)]="searchText"
            (ngModelChange)="setFilteredListItems()"
        ></agpr-text-input>

        <div
            *ngIf="showActionButton"
            class="agpr-listFilterSelect-actionButtonContainer"
        >
            <agpr-button
                [id]="id + '_listFilterActionButton'"
                class="agpr-listFilterSelect-actionButton"
                icon="fa-regular fa-duotone fa-gear"
                [agprTooltip]="actionButtonTooltip"
                tooltipPosition="left"
                [style]="buttonTypes.icon"
                (click)="actionButtonClicked.next()"
            >
            </agpr-button>
        </div>
    </div>
    <agpr-scroll-panel>
        <agpr-message
            *ngIf="noContentMessage && filteredListItems && filteredListItems.length === 0"
            [severity]="messageSeverities.noContent"
        >
            {{ noContentMessage | localize }}
        </agpr-message>
        <ng-container *ngIf="listItems != null && listItems.length !== 0">
            <cdk-virtual-scroll-viewport
                class="agpr-virtualScroll"
                [itemSize]="vsItemSize"
                [minBufferPx]="vsMinBufferPx"
                [maxBufferPx]="vsMaxBufferPx"
            >
                <ul
                    [id]="id + '_listFilterSelect'"
                    role="listbox"
                    class="agpr-listFilterSelect-list"
                    [attr.aria-label]="listAriaLabel | localize"
                    agprListKeyboardNavigation
                    [list]="filteredListItems"
                    [manageTabIndex]="false"
                    [enableNavigationCounter]="true"
                    [wrap]="false"
                >
                    <li
                        *cdkVirtualFor="let listItem of filteredListItems; let i = index"
                        role="option"
                        class="agpr-listFilterSelect-listItem"
                        [ngClass]="{'agpr-listFilterSelect-listItem--selected': listItem === selectedListItem}"
                        [attr.aria-selected]="listItem === selectedListItem"
                        tabindex="0"
                        (keydown)="onItemSelected(listItem, $event)"
                        (click)="onItemSelected(listItem)"
                    >
                        <span class="agpr-listFilterSelect-listItemLabel">{{ listItem.name }}</span>
                    </li>
                </ul>
            </cdk-virtual-scroll-viewport>
        </ng-container>
        <div
            *ngIf="listItems === null"
            class="agpr-listFilterSelect-loading"
            [agprLoading]="true"
            [agprInlineLoadingIndicator]="true"
        >
        </div>
    </agpr-scroll-panel>
</div>
